module.exports = __webpack_public_path__ + "static/media/add-bank.eaae717c.png";